module.exports = __webpack_public_path__ + "static/media/12.9052b0e5.jpg";